module.exports = __webpack_public_path__ + "assets/img/tel.e130095b.png";